import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/home/Header';
import Footer from './components/home/Footer';
import Home from './components/home/Main';
import About from './components/aboutus/Main';
import Contact from './components/contactus/Main';
import Domestic from './components/packages/domestic/Main';
import StatePage from './components/packages/domestic/state/StatePage';
import StatePlacePage from './components/packages/domestic/place/PlacePage';
import International from './components/packages/international/Main';
import CountryPage from './components/packages/international/country/CountryPage';
import CountryPlacePage from './components/packages/international/place/PlacePage';
import BookHotelResorts from './components/services/hotelbooking/Main';
import Flights from './components/services/flights/Main';
import CorporateTravels from './components/services/corporatetravels/Main';
import Visa from './components/services/visa/Main';
import Forex from './components/services/forex/Main';
import Holidays from './components/services/holidays/Main';
import TravelInsurance from './components/services/travelinsurance/Main';
import Widget from './components/home/Widget';
import ScrollToTop from './components/home/ScrollToTop';
import Service from './components/services/main/Main';
import Testimonials from './components/Testimonial/Main';
import Loader from './components/home/Loader';
import './App.css';
import CookieConsentBanner from './components/cookie/CookieConsentBanner';

// Custom Route component to handle dynamic titles
const DynamicTitleRoute = ({ element: Element, title, ...rest }) => {
  useEffect(() => {
    document.title = title || 'Default Title'; // Set the document title
    return () => {
      document.title = 'Default Title'; // Reset title when component unmounts
    };
  }, [title]);

  return <Element />;
};

function App() {
  const [loading, setLoading] = useState(true);

  // Disable right-click and dragging on all images
  useEffect(() => {
    const handleImgRightClick = (e) => {
      if (e.target.tagName === 'IMG') e.preventDefault();
    };
    const handleImgDragStart = (e) => {
      if (e.target.tagName === 'IMG') e.preventDefault();
    };
    document.addEventListener('contextmenu', handleImgRightClick);
    document.addEventListener('dragstart', handleImgDragStart);

    return () => {
      document.removeEventListener('contextmenu', handleImgRightClick);
      document.removeEventListener('dragstart', handleImgDragStart);
    };
  }, []);

  // useEffect(() => {
  //   const timer = setTimeout(() => setLoading(false), 2800);
  //   return () => clearTimeout(timer);
  // }, []);

  // if (loading) return <Loader />;

  // uncomment code if want loader 

  return (
    <>
      <Router>
        <ScrollToTop />
        <Widget />
        <Header />
        <Routes>
          <Route
            path='/'
            element={<Home />}
          />
          <Route
            path='/about-us'
            element={<About />}
          />
          <Route
            path='/contact-us'
            element={<Contact />}
          />
          <Route
            path='/domestic'
            element={<Domestic />}
          />
          <Route
            path='/domestic/:stateSlug'
            element={<StatePage />}
          />
          <Route
            path='/domestic/:stateSlug/:placeSlug'
            element={<StatePlacePage />}
          />
          <Route
            path='/international'
            element={<International />}
          />
          <Route
            path='/international/:countrySlug'
            element={<CountryPage />}
          />
          <Route
            path='/international/:countrySlug/:placeSlug'
            element={<CountryPlacePage />}
          />
          <Route
            path='/services'
            element={<Service />}
          />

          {/* Service routes with dynamic titles */}
          <Route
            path='/service/book-hotel-resorts'
            element={
              <DynamicTitleRoute
                element={BookHotelResorts}
                title='Book Hotels & Resorts'
              />
            }
          />
          <Route
            path='/service/flights'
            element={
              <DynamicTitleRoute
                element={Flights}
                title='Flights'
              />
            }
          />
          <Route
            path='/service/corporate-travels'
            element={
              <DynamicTitleRoute
                element={CorporateTravels}
                title='Corporate Travels'
              />
            }
          />
          <Route
            path='/service/visa'
            element={
              <DynamicTitleRoute
                element={Visa}
                title='Visa'
              />
            }
          />
          <Route
            path='/service/forex'
            element={
              <DynamicTitleRoute
                element={Forex}
                title='Forex'
              />
            }
          />
          <Route
            path='/service/travel-insurance'
            element={
              <DynamicTitleRoute
                element={TravelInsurance}
                title='Travel Insurance'
              />
            }
          />
          <Route
            path='/service/holidays'
            element={
              <DynamicTitleRoute
                element={Holidays}
                title='Holidays'
              />
            }
          />
          <Route
            path='/testimonials'
            element={
              <DynamicTitleRoute
                element={Testimonials}
                title='Testimonials | Bluelagoon Travels'
              />
            }
          />
        </Routes>
        <Footer />
      </Router>
      <CookieConsentBanner />
    </>
  );
}

export default App;
